import { isDefinedString } from "et3-type-guards";
import { camelCase, startCase } from "lodash";

import i18n from "../../../../../../../constants/i18n";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";
import {
  DESCRIPTION_STATUS_CHIP_FONT_SIZE,
  DESCRIPTION_STATUS_CHIP_HEIGHT,
  DESCRIPTION_STATUS_CHIP_LETTER_SPACING,
  DESCRIPTION_STATUS_CHIP_PADDING,
  DESCRIPTION_STATUS_CHIP_RADIUS_CSS
} from "./descriptions-constants";

const DescriptionStatusImage = withLiteObserverAndTheme<{
  descriptionStatus: string;
  description: string;
  toneColor: string;
  backgroundColor: string;
}>((props) => {
  const { descriptionStatus, description, toneColor, backgroundColor, theme } =
    props;
  const { unitX } = theme;
  const hasDescription = isDefinedString(description);
  const label = hasDescription
    ? startCase(camelCase(descriptionStatus))
    : i18n.get("NONE_ACTIVE");

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={DESCRIPTION_STATUS_CHIP_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={backgroundColor}
      style={{
        boxSizing: "border-box",
        width: "auto",
        flexShrink: 0,
        whiteSpace: "nowrap",
        border: `1px solid ${toneColor}`,
        borderRadius: DESCRIPTION_STATUS_CHIP_RADIUS_CSS,
        paddingLeft: DESCRIPTION_STATUS_CHIP_PADDING * unitX,
        paddingRight: DESCRIPTION_STATUS_CHIP_PADDING * unitX
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={DESCRIPTION_STATUS_CHIP_FONT_SIZE}
        text={label}
        isSpan={true}
        color={toneColor}
        style={{
          margin: 0,
          textTransform: "uppercase",
          letterSpacing: DESCRIPTION_STATUS_CHIP_LETTER_SPACING
        }}
      />
    </ET3Div>
  );
});

export default DescriptionStatusImage;
